import React from 'react';
import { Paragraph } from './Summary.styles';
import { CardBody, CardFooter, CardHeader, Button } from 'view/components/common';

interface SummaryProps 
{
    stepNavigator : (increment: boolean) => () => void;
}

export const Summary: React.FunctionComponent<SummaryProps> = ({ stepNavigator }) => 
{
    return (
        <>
            <br />
            <CardHeader content={'Complete!'} />
            <CardBody>
                <br />
                <Paragraph>
                That’s it! We have received your information and are currently processing your application. You will be notified once we make a decision with regards to funding your mortgage.
                </Paragraph>
                <Paragraph>
                If you have any questions or concerns, please email us at <a href="mailto:salaam@manzil.ca">salaam@manzil.ca</a>, and an agent will be able to serve you.
                </Paragraph>
                <br />
                <Paragraph>
                Thank you.
                </Paragraph>
            </CardBody>
            <CardFooter>
                <Button
                    title="Finish"
                    type="button"
                    disabled={false}
                    onClick={stepNavigator(true)}
                    css={'text-transform: none; padding-bottom: 3px;'}
                    arrowCss={'padding-left: 0px; margin-top: 5px;'}
                />
            </CardFooter>
        </>
    );
};

export default Summary;
